import { render, staticRenderFns } from "./BgRemoverModal.vue?vue&type=template&id=42981176"
import script from "./BgRemoverModal.vue?vue&type=script&lang=js"
export * from "./BgRemoverModal.vue?vue&type=script&lang=js"
import style0 from "./BgRemoverModal.vue?vue&type=style&index=0&id=42981176&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports